import intl from 'react-intl-universal';
import useApi from 'shared/hooks/api';
import localData from 'utils/localData';
import { PageLoader, PageError } from 'components';
import SettingsLayout from 'components/SettingsTabLayout';
import { DOLPHIN_API } from 'shared/constants/apis';
import { USER_DATA } from 'shared/constants/users';
import ProfileTab from './components/ProfileTab';
import ClientManagementTab from './components/ClientManagementTab';
import { Card } from '@mui/material';
import UserManagementTab from './components/UserManagementTab';

const DashboardOrganizationSettings = () => {
  const [{ data, error }, fetchOrganizationInfo] = useApi.useGet(
    DOLPHIN_API.ORGANIZATION_INFO,
    {
      params: {
        organizationId: localData.get(USER_DATA.CURRENT_ORGANIZATION_ID),
      },
    }
  );

  if (!data) return <PageLoader />;
  if (error)
    return (
      <PageError
        errorCode={error.response.status}
        customErrorMessage={error.response.data.message}
        customErrorDescription={error.response.data.description}
      />
    );

  const organizationInfo = { ...data };

  if (localData.get(USER_DATA.CURRENT_ORGANIZATION) !== organizationInfo.name) {
    localData.set('currentOrganization', organizationInfo.name);
  }

  const tabs = [
    {
      label: intl.get('organization_settings_tab_label_preference'),
      index: 0,
      component: <ProfileTab organizationInfo={organizationInfo} />,
    },
    {
      label: intl.get('organization_settings_tab_label_client_management'),
      index: 1,
      component: <ClientManagementTab organizationInfo={organizationInfo} />,
    },
    {
      label: intl.get('organization_settings_tab_label_user_management'),
      index: 2,
      component: (
        <UserManagementTab
          organizationInfo={organizationInfo}
          fetchOrganizationInfo={fetchOrganizationInfo}
        />
      ),
    },
  ];

  return (
    <Card sx={{ margin: 2, marginTop: 3, overflow: 'visible' }}>
      <SettingsLayout
        title={intl.get('organization_settings_text_title')}
        tabs={tabs}
      />
    </Card>
  );
};

export default DashboardOrganizationSettings;
